
import { apiCall } from "./Interceptor";

const GET_ALL_USERS = "/company-admin/getAllUsers";
const MODIFY_TRADERS = "/company-admin/modifyTraders";

const getAllCompanyAdminUsers = async () => {
    const response = await apiCall.get(GET_ALL_USERS);
    return response;
}

const modifyTraders = async(data)=>{
    const response = await apiCall.put(MODIFY_TRADERS,data);
    return response;
}

export default {
    getAllCompanyAdminUsers,
    modifyTraders,
};
